import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    destinationData: Object,
    listingsData: Array
  }
  static targets = []

  connect() {
    this.initMap()
  }

  initMap() {
    this.customerMarker = null
    this.mapMarkers = []
    this.geocoder = new google.maps.Geocoder()
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 41.215, lng: -96.112 },
      zoom: 4,
      fullscreenControl: false,
      gestureHandling: "none",
      zoomControl: false,
    });
    this.mapIw = new google.maps.InfoWindow()
    this.oms = new OverlappingMarkerSpiderfier(this.map, {
      markersWontMove: true,
      markersWontHide: true,
      basicFormatEvents: true,
      keepSpiderfied: true
    });
    this.addCustomerMarker()
    setTimeout(() => {
      this.listingsDataValue.map((listing) => this.addMapMarkerForListing(listing))
    }, 200)
  }

  async addCustomerMarker() {
    if (this.destinationDataValue.zipcode) {
      let response = await this.geocoder.geocode({ 'address': this.destinationDataValue.zipcode })
      let result = response.results[0]
      let location = result.geometry.location
      var marker = new google.maps.Marker({ position: { lat: location.lat(), lng: location.lng() }, icon: { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png', scaledSize: new google.maps.Size(40, 40) }, optimized: true })
      google.maps.event.addListener(marker, 'spider_click', (e) => {
        this.mapIw.setContent("<div class='mb-2 text-lg font-semibold'>Customer:</div><p>" + result.formatted_address + "</p><p>" + this.destinationDataValue.title+"</p>")
        this.mapIw.open(this.map, marker)
      })
      this.oms.addMarker(marker)
      this.customerMarker = marker
      this.fitMapToMarkerBounds()
    }
  }

  async addMapMarkerForListing(listing) {
    let response = await this.geocoder.geocode({ 'address': listing.zipcode })
    let result = response.results[0]
    let location = result.geometry.location
    let icon_url = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
    var marker = new google.maps.Marker({ position: { lat: location.lat(), lng: location.lng() }, icon: { url: icon_url, scaledSize: new google.maps.Size(40, 40) }, optimized: true })
    this.mapMarkers.push({ id: listing.id, marker: marker })
    google.maps.event.addListener(marker, 'spider_click', (e) => {
      let markerContent = "<div class='mb-2 text-lg font-semibold'>Listing:</div><p class='mb-1 text-md font-medium'>" + listing.title + "</p><p class='mb-1'>" + result.formatted_address + "</p>"
      this.mapIw.setContent(markerContent)
      this.mapIw.open(this.map, marker)
    })
    this.oms.addMarker(marker)
    this.fitMapToMarkerBounds()
    this.drawLineToDestination(location)
  }

  fitMapToMarkerBounds() {
    var bounds = new google.maps.LatLngBounds();
    this.mapMarkers.map((listingMarker) => bounds.extend({ lat: listingMarker.marker.position.lat(), lng: listingMarker.marker.position.lng() }))
    if (this.customerMarker) {
      bounds.extend({ lat: this.customerMarker.position.lat(), lng: this.customerMarker.position.lng() })
    }
    this.map.fitBounds(bounds);
  }

  drawLineToDestination(location) {
    if (this.customerMarker) {
      var line = new google.maps.Polyline({
        path: [{ lat: this.customerMarker.position.lat(), lng: this.customerMarker.position.lng() }, { lat: location.lat(), lng: location.lng() }],
        geodesic: true,
        strokeColor: '#4169e1',
        strokeOpacity: 1.0,
        strokeWeight: 2
      })

      line.setMap(this.map)
    }
  }

}